import { render, staticRenderFns } from "./snippet_description_view.vue?vue&type=template&id=421b9fc8"
import script from "./snippet_description_view.vue?vue&type=script&lang=js"
export * from "./snippet_description_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports